import { request } from '.';
import { setUiState } from './ui';

const SET_MEMBERSHIPLANS = 'SET_MEMBERSHIPLANS';
const SET_MEMBERSHIPLAN = 'SET_MEMBERSHIPLAN';

const defaultState = { membershiplans: null, membershiplan: null };

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_MEMBERSHIPLANS:
      return { ...state, membershiplans: action.payload, membershiplan: null };

    case SET_MEMBERSHIPLAN:
      return { ...state, membershiplan: action.payload };

    default:
      return state;
  }
}
export function setPlans(plans) {
  return {
    type: SET_MEMBERSHIPLANS,
    payload: plans
  };
}

export function setPlan(plan) {
  return {
    type: SET_MEMBERSHIPLAN,
    payload: plan
  };
}

export function getMemberShipPlans(sort_by, sort_order, search) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const params = { internal: 'true' };
        if (sort_by) params.sort_by = sort_by;
        if (sort_order) params.sort_order = sort_order;
        if (search) params.search = search;

        const url = '/internal/organizations/membership/plans';
        dispatch(setUiState('loading'));
        const response = await request.get(url, { params });
        await dispatch(setPlans(response.data));
        if (response.data.length > 0) {
          dispatch(setUiState('complete'));
        } else {
          dispatch(setUiState('empty'));
        }

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        console.error(e);
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/redux/membership.js